export class ClientRegister {
  public ContractNumber: string;
  public SerialNumber: string;
  public Registration: string;
  public UserID: string;
  public Password: string;
  public ConfirmPassword: string;
  public SecretQuestion: string;
  public SecretAnswer: string;
  public CompanyName: string;
  public FirstName: string;
  public LastName: string;
  public Phone: string;
  public Fax: string;
  public Email: string;
  public IsAgreement: boolean;
  public UniversalEmail: string;
  public  UniversalGuid: string;
  public universalFlag: boolean;

}



// WEBPACK FOOTER //
// ./src/app/models/ClientRegister.ts